import { getPageSizeOptions } from "./getPageSizeOptions";

/**
 * Find the closest valid page size based on available options
 * @param currentSize - The current page size
 * @param totalItems - Total number of items to determine available options
 * @returns The closest valid page size
 */
const getClosestPageSize = (
  currentSize: number,
  totalItems: number,
): number => {
  const options = getPageSizeOptions(totalItems);

  // If current size is already in options, keep it
  if (options.includes(currentSize)) {
    return currentSize;
  }

  // Find the closest smaller option
  const smallerOptions = options.filter((option) => option <= currentSize);

  if (smallerOptions.length > 0) {
    return Math.max(...smallerOptions);
  }

  // If no smaller option, use the largest available
  return Math.max(...options);
};

/**
 * Validate and adjust page size based on total items
 * @param itemsPerPage - Current items per page
 * @param totalItems - Total number of items
 * @returns Object with validPageSize and shouldUpdate flag
 */
export const validatePageSize = (
  itemsPerPage: number,
  totalItems: number,
): { shouldUpdate: boolean; validPageSize: number } => {
  const validPageSize = getClosestPageSize(itemsPerPage, totalItems);

  return {
    shouldUpdate: validPageSize !== itemsPerPage,
    validPageSize,
  };
};
